import { unique } from "@@/utilities/unique";
import type { PayRequestEvent } from "./events/_pay-request.event";
import type { PayRequestId } from "./pay-request-id";

const noEventsForPayRequestCheck = (
    payRequestId: PayRequestId,
    events: PayRequestEvent[]
) => {
    const eventCount = events.filter(
        item => item.payRequestId === payRequestId
    ).length;
    if (!eventCount) {
        throw new Error(
            `There are no events for this pay request id amongst the provided events; payRequestId: ${payRequestId}, events for : ${
                unique(events.map(event => event.payRequestId)).join(", ") ||
                "none"
            }`
        );
    }
};

export { noEventsForPayRequestCheck };
